import { render } from "./FluxoCompletoComponent.vue?vue&type=template&id=a89d3e86&scoped=true"
import script from "./FluxoCompletoComponent.vue?vue&type=script&lang=js"
export * from "./FluxoCompletoComponent.vue?vue&type=script&lang=js"

import "./FluxoCompletoComponent.vue?vue&type=style&index=0&id=a89d3e86&scoped=true&lang=css"
import "./FluxoCompletoComponent.vue?vue&type=style&index=1&id=a89d3e86&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a89d3e86"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QVideo from 'quasar/src/components/video/QVideo.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QRadio from 'quasar/src/components/radio/QRadio.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QLinearProgress from 'quasar/src/components/linear-progress/QLinearProgress.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QTh from 'quasar/src/components/table/QTh.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QVirtualScroll from 'quasar/src/components/virtual-scroll/QVirtualScroll.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QPopupProxy from 'quasar/src/components/popup-proxy/QPopupProxy.js';
import QDate from 'quasar/src/components/date/QDate.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QField from 'quasar/src/components/field/QField.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QIcon,QVideo,QInput,QSelect,QRadio,QTable,QImg,QCardSection,QBtn,QLinearProgress,QTr,QTh,QTd,QVirtualScroll,QTooltip,QPopupProxy,QDate,QDialog,QCard,QField});qInstall(script, 'directives', {ClosePopup});
